import React, { useCallback } from "react";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import "./Lantronix.css";
import Icons from "./Common/IconsGroup";
import HeaderImage from "./images/partners_header_image.png";
import NetworkImage from "./images/partners_network.png";
import CloudImage from "./images/cloud.png";
import MobileImage from "./images/mobile.png";
import FoxDeviceImage from "./images/fox_device.png";
import AntennaImage from "./images/antenna.png";

const PARTNER_SOLUTIONS = [
  {
    icon: Icons(0, 0, "", "partners__card-icon-svg").energy(),
    title: "01 / Energy",
    subTitle: "Up to 30% lower energy cost",
    info: "Smart load and unload tracking with leak detection.",
  },
  {
    icon: Icons(
      0,
      0,
      "",
      "partners__card-icon-svg-monitor"
    ).monitor(),
    title: "02 / Monitoring",
    subTitle: "Any compressor, any vendor",
    info: "Real-time visibility into pressure, temperature, and energy.",
  },
  {
    icon: Icons(0, 0, "", "partners__card-icon-svg").wrench(),
    title: "03 / Service",
    subTitle: "Plan service, don't react",
    info: "Run-hour scheduling, remote diagnostics, centralized history.",
  },
  {
    icon: Icons(
      0,
      0,
      "",
      "partners__card-icon-svg-board"
    ).clipboard(),
    title: "04 / Compliance",
    subTitle: "Automated ISO 50001 reporting",
    info: "Continuous CO₂ and energy data for ESG submissions.",
  },
];

const PARTNER_SUBSCRIPTIONS = [
  {
    icon: CloudImage,
    title: "Utvyakta Platform",
    subTitle: "Cloud analytics",
    info: "The Kompress.ai algorithms, running on your live compressor data.",
  },
  {
    icon: MobileImage,
    title: "Utvyakta Platform",
    subTitle: "Mobile app",
    info: "Field installation, alerts, and remote diagnostics on the go.",
  },
  {
    icon: FoxDeviceImage,
    title: "Lantronix Hardware",
    subTitle: "FOX IoT gateway",
    info: "Industrial-grade gateway that connects any compressor, any age.",
  },
  {
    icon: AntennaImage,
    title: "Lantronix Connectivity",
    subTitle: "Cellular data plan",
    info: "Coverage included for the full subscription term.",
  },
];

const PartnerCard = ({
  icon,
  title,
  subTitle,
  info,
  subscription = false,
  className = ""
}) => (
  <div
    className={
      subscription
        ? "partners__card-partners__card--subscription"
        : "partners__card"
    }
  >
    <div className={subscription ? `partners__subscription-card-icon ${className}` : "partners__card-icon"}>
      {subscription ? <img className="partners__subscription-card-img" src={icon} alt="" /> : icon}
    </div>

    <h2
      className={
        subscription
          ? "partners-sollution-card-section-subscription-title"
          : "partners__card-title"
      }
    >
      {title}
    </h2>

    <h5 className="partners__card-subtitle">
      {subTitle}
    </h5>

    <span className="partners__card-description">{info}</span>
  </div>
);

const Lantronix = () => {

  const openLantronix = useCallback(() => {
    window.open(
      "https://www.lantronix.com/kompress/",
      "_blank",
      "noopener,noreferrer"
    );
  }, []);

  const renderCTA = () => (
    <div
    className="partners-banner-btn-container"
    onClick={openLantronix}
    >
      <div
        className="partners__button"
      >
        Visit Kompress.ai by Lantronix
      </div>
      <span>&#8594;</span>
    </div>
  );

  return (
    <>
      <Header />

      <div className="partners__banner">
        <div className="partners__banner-content">
          <div className="partners__banner-left">

            <span className="partners__title">
              Kompress.ai, now in{" "}
              <b className="partners__title-sub-info">
                North America & Europe
              </b>{" "}
              with Lantronix
            </span>

            <span className="partners__description">
              Lantronix is our solution and reseller partner for North America
              and Europe. Their FOX IoT gateway and cellular connectivity carry
              our Kompress.ai algorithms, and their channel brings the offering
              to compressor operators across both regions.
            </span>

            {renderCTA()}
          </div>

          <div className="partners__banner-image">
            <img
              src={HeaderImage}
              alt="Kompress.ai and Lantronix partnership"
            />
          </div>
        </div>
      </div>

      <div className="partners__solution">
        <span className="heading white-heading partners__solution-title">
          Four Outcomes the Joint Solution is Built to Deliver.
        </span>

        <div className="partners__cards">
          {PARTNER_SOLUTIONS.map((item) => (
            <PartnerCard key={item.title} {...item} />
          ))}
        </div>
      </div>

      <div className="partners-sollution-subscription-container">
        <span className="heading white-heading partners__solution-title">
          One Subscription. Everything Needed to Put a Fleet Online.
        </span>

        <div className="partners-sollution-card-section-subscription-container">
          {PARTNER_SUBSCRIPTIONS.map((item, i) => (
            <PartnerCard
              key={`${item.title}-${item.subTitle}`}
              {...item}
              className={i === 1 ? "partners__card-partners__card--subscription-mobile" : ""}
              subscription
            />
          ))}
        </div>
      </div>

      <div className="partners__network">
        <div className="partners__network-content">
          <span className="partners__network-title">
            Available in{" "}
            <b className="partners__title-sub-info">North America & Europe</b>
          </span>

          <span className="partners__network-title">
            Ready to put your compressor fleet on Kompress.ai?
          </span>

          <span className="partners__description">
            Kompress.ai by Lantronix is available across North America and
            Europe through Lantronix sales and authorized channel partners.
          </span>

          {renderCTA()}
        </div>

        <div className="partners__banner-image">
          <img
            src={NetworkImage}
            alt="Kompress.ai availability across North America and Europe"
          />
        </div>
      </div>

      <Footer />
    </>
  );
};

export default React.memo(Lantronix);